import { useEffect, useState } from "react";
import { Button, Card, Form, FormControl, InputGroup, Modal, Nav, Tab, ToggleButton, } from "react-bootstrap";
import moment from "moment";
import { formateDateUS, quoteToDoubleQuote } from "./utils/Columns";
import NewDropdown from "./NewDropdown";
import TribuManage from "./TribuManage";

const AdherentUpdateById = ({ reloadData, blocs, champs, adherentId, code, gotoAuth, close, tribus }) => {
    const url = localStorage.getItem("url");
    const annee = localStorage.getItem("annee");

    useEffect(() => {
        getAdherent();
    }, [adherentId]);

    const getAdherent = () => {
        fetch(`${url}GetAdherentById/${adherentId}/${code}`)
            .then((response) => response.json())
            .then((data) => {
                if (data === "0" || !data.data) gotoAuth();
                else {
                    let adh = JSON.parse(
                        JSON.stringify({ ...data.data[0] }).replace(/{}/g, '""')
                    );

                    console.log("res", adh);

                    adh.date_paiement = formateDateUS(adh.date_paiement);
                    adh.fin_periode = formateDateUS(adh.fin_periode);
                    adh.enregistre_site_ffc = formateDateUS(adh.enregistre_site_ffc);
                    adh.enregistre_site_mediation = formateDateUS(
                        adh.enregistre_site_mediation
                    );
                    adh.date_de_reglement = formateDateUS(adh.date_de_reglement);
                    adh.date_de_reglement_siv = formateDateUS(adh.date_de_reglement_siv);
                    adh.fin_periode_siv = formateDateUS(adh.fin_periode_siv);
                    setEditedAdherent({ ...adh });
                }
            })
            .catch((error) => console.error("Erreur:", error));
    };

    const handleSaveAdherent = (adh) => {
        let editedAdh = {
            ...adh,
        };
        fetch(`${url}SaveAdherent/${code}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(quoteToDoubleQuote(editedAdh)).replace(
                /"Invalid date"/g,
                '""'
            ),
        })
            .then((response) => response.json())
            .then((data) => {
                reloadData();
                close();
            })
            .catch((error) => console.error("Erreur:", error));
    };

    const [editedAdherent, setEditedAdherent] = useState({
        prenom_adherent: "",
        nom_adherent: "",
        adresse1: "",
        adresse2: "",
        code_postal: "",
        ville: "",
        telephone: "",
        numero_de_portable: "",
        e_mail_1: "",
        e_mail_2: "",
        e_mail_3: "",
        civilite: "M",
        numero_de_dpt: "",
        numero_client: "",
        region: "",
        nom_de_l_entreprise: "",
        siret: "",
        numero_tva_intracommunautaire: "",
        code_ape_ou_naf: "4519 Z",
        forme_juridique_de_la_societe: "SCS",
        montant_du_capital: 0,
        code_metier: "",
        nbre_productifs: 1,
        nbre_apprentis: 0,
        total_personnel: 1,
        enregistre_site_ffc: "",
        enregistre_site_mediation: "",
        reseau: "",
        adh_depuis: "",
        annee_de_cotisation: 0,
        date_paiement: "",
        cotisation_nationale_t1: 0,
        cotisation_reseau: 0,
        cotisation_regionale: 0,
        cotisation_3_ans: "",
        mode_de_paiement: "",
        paiement_en_x_fois: 0,
        cnpa: "",
        fnaa: "",
        autre: "",
        cotisation_id: 0,
        numero_de_feuille_de_cotisation: 0,
        ou_numero_de_feuille_de_cotisation: 0,
        has_tribu: 0,
        date_de_reglement: "",
        fin_periode: "",
        montant_tribu_regle_t2: 0,
        moyen_de_paiement: "",
        identifiant_tribu: "",
        has_siv: 0,
        date_de_reglement_siv: "",
        fin_periode_siv: "",
        montant_regle_siv: 0,
        moyen_de_paiement_siv: "",
        paiement_en_x_fois_siv: 1,
        membre_bureau_ffc: "",
        membre_conseil_national: "",
        membres_conseil_admin: "",
        titre: "",
        choix_id: "",
        paiement_montant: 0,
        tribu_montant: 0,
        code: "",
        bic: "",
        iban: "",
        bictmp: "",
        ibantmp: "",
        rum: "",
        anneeSel: "",
    });

    const [villes, setVilles] = useState([]);
    const [showVilles, setShowVilles] = useState(false);

    const getCp = (cp) => {
        fetch(`${url}GetVilles/${cp}`)
            .then((response) => response.json())
            .then((data) => {
                console.log("Réponse du serveur:", data);
                let res = data.data;
                setVilles(res);
                if (res.length === 1)
                    setEditedAdherent({ ...editedAdherent, ville: res[0] ? res[0].localite : "", code_postal: cp });
                else if (res.length > 1) setShowVilles(true);
            })
            .catch((error) => console.error("Erreur:", error));
    };
    const handleVilleSelected = (ville) => {
        setEditedAdherent({ ...editedAdherent, ville: ville });
        setShowVilles(false);
    };


    const [allRequiredFieldsFilled, setAllRequiredFieldsFilled] = useState(false);
    const [dropdown, setDropdown] = useState(
        JSON.parse(localStorage.getItem("dropdown"))
    );
    const [activeKey, setActiveKey] = useState(""); // activeKey par défaut
    const [requiredFields, setRequiredFields] = useState([]);

    const getAnnee = () => {
        let annee = localStorage.getItem("annee");
        console.log("annee", annee);
        if (annee && annee.length === 4) {
            setEditedAdherent({ ...editedAdherent, anneeSel: annee });
        } else
            setTimeout(() => {
                getAnnee();
            }, 2000);
    };
    useEffect(() => {
        getAnnee();
    }, []);

    useEffect(() => {
        if (code) handleInputChange("code", code);
    }, [code]);

    useEffect(() => {
        verifAllRequiredFieldsFilled(editedAdherent);
    }, [editedAdherent]);

    const saveAdherent = () => {
        let editedAdh = {
            ...editedAdherent,
            date_paiement: moment(editedAdherent.date_paiement).format("YYYY-MM-DD"),
            fin_periode: moment(editedAdherent.fin_periode).format("YYYY-MM-DD"),
            enregistre_site_ffc: moment(editedAdherent.enregistre_site_ffc).format(
                "YYYY-MM-DD"
            ),
            enregistre_site_mediation: moment(
                editedAdherent.enregistre_site_mediation
            ).format("YYYY-MM-DD"),
            date_de_reglement: moment(editedAdherent.date_de_reglement).format(
                "YYYY-MM-DD"
            ),
            date_de_reglement_siv: moment(editedAdherent.date_de_reglement_siv).format(
                "YYYY-MM-DD"
            ),
            fin_periode_siv: moment(editedAdherent.fin_periode_siv).format("YYYY-MM-DD"),
        };
        handleSaveAdherent(editedAdh);
    };

    const verifAllRequiredFieldsFilled = (adherent) => {
        const areAllRequiredFieldsFilled = requiredFields.every((e) => {
            if (typeof adherent[e.field] === "number") {
                return adherent[e.field] > 0;
            } else {
                // console.log(e.field)
                return (
                    adherent[e.field].trim() !== "" &&
                    (!e.longueur ||
                        (e.longueur && adherent[e.field].length === e.longueur))
                );
            }
        });
        setAllRequiredFieldsFilled(areAllRequiredFieldsFilled);

        let tableauDataTmp = [...tableauData];
        tableauDataTmp.forEach((el) => {
            const areAllRequiredFieldsFilledOfKey = requiredFields
                .filter((ele) => ele.key === el.key)
                .every((e) => {
                    if (typeof adherent[e.field] === "number") {
                        return adherent[e.field] > 0;
                    } else {
                        return (
                            adherent[e.field].trim() !== "" &&
                            (!e.longueur ||
                                (e.longueur && adherent[e.field].length === e.longueur))
                        );
                    }
                });
            el.requiredFieldsFilled = areAllRequiredFieldsFilledOfKey;
        });
        setTableauData(tableauDataTmp);
    };

    const handleInputChange = (field, value) => {
        console.log(field, value);

        let newEditedAdherent = { ...editedAdherent };

        if (field === "code_postal") {
            if (value.length === 5) { getCp(value); }
            newEditedAdherent = {
                ...editedAdherent,
                [field]: value,
                numero_de_dpt: value.length >= 2 ? value.substring(0, 2) : "",
            };
        } else if (["numero_de_portable", "telephone"].includes(field)) {
            const phoneNumber = value.replace(/\s/g, "");
            let formattedPhoneNumber = "";
            if (phoneNumber.length === 3)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{1})/, "$1 $2");
            else if (phoneNumber.length === 4)
                formattedPhoneNumber = phoneNumber.replace(/(\d{2})(\d{2})/, "$1 $2");
            else if (phoneNumber.length === 5)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{1})/,
                    "$1 $2 $3"
                );
            else if (phoneNumber.length === 6)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})/,
                    "$1 $2 $3"
                );
            else if (phoneNumber.length === 7)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{1})/,
                    "$1 $2 $3 $4"
                );
            else if (phoneNumber.length === 8)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{2})/,
                    "$1 $2 $3 $4"
                );
            else if (phoneNumber.length === 9)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{2})(\d{1})/,
                    "$1 $2 $3 $4 $5"
                );
            else if (phoneNumber.length === 10)
                formattedPhoneNumber = phoneNumber.replace(
                    /(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/,
                    "$1 $2 $3 $4 $5"
                );
            else formattedPhoneNumber = phoneNumber;
            newEditedAdherent = { ...editedAdherent, [field]: formattedPhoneNumber };
        } else {
            newEditedAdherent = { ...editedAdherent, [field]: value };
        }

        setEditedAdherent(newEditedAdherent);

        verifAllRequiredFieldsFilled(newEditedAdherent);
    };

    const getInput = (key, libelle, field) => {
        // console.log('getInput', key, libelle, field);
        let champ = champs.find((el) => el.lib === field);
        if (!champ) return <></>;

        let value = editedAdherent[field];
        // console.log(value, typeof value, value.length, champ.longueur, value.length !== champ.longueur);
        if (champ.required && !requiredFields.map((e) => e.field).includes(field))
            setRequiredFields([
                ...requiredFields,
                { field: field, longueur: champ.longueur, key: key },
            ]);

        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        // console.log('getInput', key, libelle, field, value, champ, `Value = "${value}"`, value && value.trim() === '' ? 'has-error' : 'pas d`errreur');
        return (
            <>
                <InputGroup
                    className={`mb-3 ${champ.required &&
                        ((champ.longueur && value.length !== champ.longueur) ||
                            value.length === 0)
                        ? "has-error"
                        : ""
                        }`}
                    key={key + field}
                >
                    <InputGroup.Text
                        className={
                            champ.required &&
                                ((champ.longueur && value.length !== champ.longueur) ||
                                    value.length === 0)
                                ? "border-danger"
                                : ""
                        }
                    >
                        {libelle}
                        {champ.required && <span style={{ color: "red" }}>&nbsp;*</span>}
                    </InputGroup.Text>
                    <FormControl
                        value={value}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        maxLength={champ.longueur}
                    />
                </InputGroup>
                {champ.longueur && value.length !== champ.longueur && (
                    <div>
                        {/* Add a message to inform that required fields are mandatory */}
                        <p style={{ color: "red" }}>
                            Ce champ doit faire {champ.longueur} caractères
                        </p>
                    </div>
                )}
            </>
        );
    };

    const getInputNumber = (key, libelle, field) => {
        let value = editedAdherent[field];

        //Tous les champs number sont obligatoires (pas vide)
        let champ = champs.find((el) => el.lib === field);
        if (!champ) return <></>;
        if (champ.required && !requiredFields.map((e) => e.field).includes(field))
            setRequiredFields([
                ...requiredFields,
                { field: field, longueur: champ.longueur, key: key },
            ]);

        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return (
            <InputGroup className={`mb-3 ${value === '' ? "has-error" : ""}`}
                key={field}>
                <InputGroup.Text className={value === '' ? "border-danger" : ""}>{libelle}</InputGroup.Text>
                <FormControl
                    min="0"
                    type="number"
                    value={value === 0 ? "" : value}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                />
            </InputGroup>
        );
    };
    /*
    const getInputNumber = (key, libelle, field) => {
      let value = editedAdherent[field];
      // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
      return (
        <InputGroup className="mb-3" key={field}>
          <InputGroup.Text>{libelle}</InputGroup.Text>
          <FormControl
            min="0"
            type="number"
            value={value}
            onChange={(e) => handleInputChange(field, e.target.value)}
          />
        </InputGroup>
      );
    };
    */

    const handleInputChangeDate = (field, value) => {
        // Vérifie si la date est au format valide ou vide ou null
        if (value === "" ||
            value === null ||
            moment(value, "YYYY-MM-DD", true).isValid() ||
            moment(value, "DD/MM/YYYY", true).isValid()
        ) {
            let newEditedAdherent = { ...editedAdherent, [field]: value };
            setEditedAdherent(newEditedAdherent);
            verifAllRequiredFieldsFilled(newEditedAdherent);
        }
    };

    const getDate = (libelle, field) => {
        let value = editedAdherent[field];
        console.log("getDate", libelle, field, value);
        return (
            <InputGroup className="mb-3" key={field}>
                <InputGroup.Text>{libelle}</InputGroup.Text>
                <FormControl
                    type="date"
                    value={value}
                    onChange={(e) => handleInputChangeDate(field, e.target.value)}
                />
            </InputGroup>
        );
    };
    const getYesNo = (libelle, field) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        let value = editedAdherent[field];
        return (
            <InputGroup className="mb-3" key={field} width="100%">
                <InputGroup.Text className="flex-grow-1">{libelle}</InputGroup.Text>
                <ToggleButton
                    id={"toggle-check-oui" + field}
                    type="checkbox"
                    variant={value === 1 ? "success" : "outline-success"} // 'light' pour la variante "Non"
                    checked={value === 1}
                    onChange={(e) => handleInputChange(field, 1)}
                >
                    Oui
                </ToggleButton>

                <ToggleButton
                    id={"toggle-check-non" + field}
                    type="checkbox"
                    variant={value === 0 ? "danger" : "outline-danger"} // 'light' pour la variante "Oui"
                    checked={value === 0}
                    onChange={(e) => handleInputChange(field, 0)}
                >
                    Non
                </ToggleButton>
            </InputGroup>
        );
    };

    const handleNewType = (field, value) => {
        setDropdown(JSON.parse(localStorage.getItem("dropdown")));
        handleInputChange(field, value);
    };

    const getSelectAndAdd = (libelle, field, options, type) => {
        // console.log('getSelectAndAdd', libelle, field, options, type);
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return (
            <InputGroup className="mb-3" key={field}>
                <InputGroup.Text>{libelle}</InputGroup.Text>
                <Form.Select
                    value={editedAdherent[field]}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                >
                    {options.map((item, index) => (
                        <option key={index} value={item}>
                            {item}
                        </option>
                    ))}
                </Form.Select>
                <NewDropdown type={type} field={field} handleNewType={handleNewType} />
            </InputGroup>
        );
    };

    const getSelect = (libelle, field, options) => {
        // getInput('Adresse 1', 'adresse1', editedAdherent.adresse1)
        return (
            <InputGroup className="mb-3" key={field}>
                <InputGroup.Text>{libelle}</InputGroup.Text>
                <Form.Select
                    value={editedAdherent[field]}
                    onChange={(e) => handleInputChange(field, e.target.value)}
                >
                    {options.map((item, index) => (
                        <option key={index} value={item}>
                            {item}
                        </option>
                    ))}
                </Form.Select>
            </InputGroup>
        );
    };

    const tableauData1 = [
        {
            key: "infoAdh",
            libelle: "Informations adhérent",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getInput("infoAdh", "Numéro client", "numero_client")}
                    {champs.find((el) => el.lib === "civilite") &&
                        getSelect(
                            "Civilité",
                            "civilite",
                            dropdown
                                .filter((el) => el.type === "civilite")
                                .map((el) => el.libelle)
                        )}
                    {getInput("infoAdh", "Prénom", "prenom_adherent")}
                    {getInput("infoAdh", "Nom", "nom_adherent")}
                    {getInput("infoAdh", "Adresse 1", "adresse1")}
                    {getInput("infoAdh", "Adresse 2", "adresse2")}
                    {getInput("infoAdh", "Code Postal", "code_postal")}
                    {getInput("infoAdh", "Ville", "ville")}
                    {getInput("infoAdh", "Téléphone 1", "telephone")}
                    {getInput("infoAdh", "Téléphone 2", "numero_de_portable")}
                    {getInput("infoAdh", "E-mail du service atelier", "e_mail_1")}
                    {getInput("infoAdh", "E-mail 2", "e_mail_2")}
                    {getInput("infoAdh", "E-mail 3", "e_mail_3")}
                    {getSelect(
                        "Région",
                        "region",
                        dropdown
                            .filter((el) => el.type === "region")
                            .map((el) => el.libelle)
                    )}
                </>
            ),
        },
        {
            key: "entreprise",
            libelle: "Entreprise",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getInput("entreprise", "Entreprise", "nom_de_l_entreprise")}
                    {getInput("entreprise", "Siret", "siret")}
                    {getInput(
                        "entreprise",
                        "Numéro TVA Intracommunautaire",
                        "numero_tva_intracommunautaire"
                    )}
                    {getSelect(
                        "Code APE ou NAF",
                        "code_ape_ou_naf",
                        dropdown.filter((el) => el.type === "ape").map((el) => el.libelle)
                    )}
                    {getSelect(
                        "Forme Juridique",
                        "forme_juridique_de_la_societe",
                        dropdown
                            .filter((el) => el.type === "societe")
                            .map((el) => el.libelle)
                    )}
                    {getInputNumber("entreprise", "Montant du Capital", "montant_du_capital")}
                    {getSelect(
                        "Métier",
                        "code_metier",
                        dropdown
                            .filter((el) => el.type === "metier")
                            .map((el) => el.libelle)
                    )}
                    {/* {getInput('entreprise', 'Code Métier', 'code_metier')} */}
                </>
            ),
        },
        {
            key: "effectif",
            libelle: "Effectif",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getInputNumber("effectif", "Nombre Productifs affectés à l'atelier", "nbre_productifs")}
                    {getInputNumber("effectif", "Nombre Apprentis", "nbre_apprentis")}
                    {getInputNumber("effectif", "Total Personnel", "total_personnel")}
                    {/* {getText('Total Personnel', 'total_personnel')} */}
                </>
            ),
        },
        {
            key: "adhesion",
            libelle: "Adhésion",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getSelectAndAdd(
                        "Réseau",
                        "reseau",
                        [
                            "",
                            ...dropdown
                                .filter((el) => el.type === "reseau")
                                .map((el) => el.libelle),
                        ],
                        "reseau"
                    )}
                    {getInputNumber("reseau", "Adhérent Depuis", "adh_depuis")}
                    {getInputNumber("reseau", "Année de Cotisation", "annee_de_cotisation")}
                    {getDate("Date de Paiement", "date_paiement")}
                    {getInputNumber("reseau", "Cotisation Nationale", "cotisation_nationale_t1")}
                    {getInputNumber("reseau", "Cotisation Réseau", "cotisation_reseau")}
                    {getInputNumber("reseau", "Cotisation Régionale", "cotisation_regionale")}
                    {getInput("adhesion", "Cotisation 3 Ans", "cotisation_3_ans")}
                    {getSelect(
                        "Mode de Paiement",
                        "mode_de_paiement",
                        dropdown
                            .filter((el) => el.type === "paiement")
                            .map((el) => el.libelle)
                    )}
                    {getSelect("Paiement en X Fois", "paiement_en_x_fois", ["1", "2", "3", "4", "5", "6",])}
                    {/* {getInputNumber('Paiement en X Fois', 'paiement_en_x_fois')} */}
                    {getInput("adhesion", "CNPA", "cnpa")}
                    {getInput("adhesion", "FNAA", "fnaa")}
                    {getInput("adhesion", "Autre", "autre")}
                    {/* {getInput('adhesion', 'Choix Cotisa tion', 'cotisation_id')} */}
                </>
            ),
        },
        {
            key: "abonnement",
            libelle: "Abonnement",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNo("Abonné FFC Experts", "abonne_ffc_expert")}
                    {getYesNo("Abonné Mag Carrosserie", "abonne_mag_carrosserie")}
                    {getYesNo("Abonné Profession Carrossier", "abonne_profession_carrossier")}
                    {getYesNo("Accès Site FFC Newsletter", "acces_site_ffc_newsletter")}
                    {getDate("Date enregistrement site FFC", "enregistre_site_ffc")}
                    {getYesNo("Accès Médiateur Consommation", "acces_mediateur_consommation")}
                    {getDate("Date enregistrement site médiation", "enregistre_site_mediation")}
                </>
            ),
        },
        {
            key: "tribu",
            libelle: "Tribu",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNo("Abonné Tribu", "has_tribu")}
                    {getDate("Date de Règlement", "date_de_reglement")}
                    {getDate("Fin Période", "fin_periode")}
                    {getInputNumber("tribu", "Montant Tribu Réglé", "montant_tribu_regle_t2")}
                    {getSelect("Moyen de Paiement", "moyen_de_paiement",
                        dropdown
                            .filter((el) => el.type === "paiement")
                            .map((el) => el.libelle)
                    )}
                    {getSelect("Paiement en X Fois", "paiement_en_x_fois", ["1", "2", "3", "4", "5", "6",])}
                    {/* {getInput('tribu', 'Paiement en X Fois', 'paiement_en_x_fois')} */}
                    {getInput("tribu", "Identifiant Tribu", "identifiant_tribu")}
                </>
            ),
        },
        {
            key: "siv",
            libelle: "SIV",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNo("Abonné SIV", "has_siv")}
                    {getDate("Date de Règlement SIV", "date_de_reglement_siv")}
                    {getDate("Fin Période SIV", "fin_periode_siv")}
                    {getInputNumber("siv", "Montant SIV Réglé", "montant_regle_siv")}
                    {getSelect("Moyen de Paiement SIV", "moyen_de_paiement_siv",
                        dropdown
                            .filter((el) => el.type === "paiement")
                            .map((el) => el.libelle)
                    )}
                    {getSelect("Paiement en X Fois SIV", "paiement_en_x_fois_siv", ["1", "2", "3", "4", "5", "6",])}
                </>
            ),
        },
        {
            key: "membre",
            libelle: "Membre",
            requiredFieldsFilled: true,
            corps: (
                <>
                    {getYesNo("Membre Bureau FFC", "membre_bureau_ffc")}
                    {getYesNo("Membre Conseil National", "membre_conseil_national")}
                    {getYesNo("Membres Conseil Admin", "membres_conseil_admin")}
                    {getInput("membre", "Titre", "titre")}
                </>
            ),
        },
    ];

    // const tableauData = tableauData1.filter(el => blocs.includes(el.key));
    const [tableauData, setTableauData] = useState([]);

    useEffect(() => {
        setTableauData(tableauData1.filter((el) => blocs.includes(el.key)));
        if (activeKey === "") setActiveKey(blocs[0]);
    }, [blocs]);

    const renderModalContent = (data) => {
        return (
            <Card>
                <Card.Header>
                    <div className="d-flex justify-content-between">
                        <h5>{data.libelle}</h5>
                    </div>
                </Card.Header>
                <Card.Body>
                    {'Tribu' === data.libelle && editedAdherent.tft_login !== undefined && (
                        <div className="row">
                            <div className="col-6">
                                {data.corps}
                            </div>
                            <div className="col-6">
                                {/* {JSON.stringify(tribus)}
                <hr />
                {JSON.stringify(editedAdherent)} */}
                                {tribus && tribus.length > 0 && editedAdherent.tft_login !== undefined && (<TribuManage annee={annee} adherentSelect={editedAdherent} tribus={tribus} handleAfterModif={() => { alert('Pour rafraichir les données de tribu fermez cette pop up') }} />)}
                            </div>
                        </div>
                    )}
                    {!('Tribu' === data.libelle && editedAdherent.tft_login !== undefined) && data.corps}

                </Card.Body>
            </Card>
        );
    };

    return (
        <>
            {/* {JSON.stringify(editedAdherent)} */}
            {/* tribus : {JSON.stringify(tribus)} */}
            {champs.length > 0 && blocs.length > 0 && tableauData.length > 0 && (
                <div>
                    <Tab.Container
                        activeKey={activeKey}
                        onSelect={(key) => setActiveKey(key)}
                    >
                        {blocs.length > 1 && (
                            <Nav variant="tabs">
                                {tableauData.map((item, index) => (
                                    <Nav.Item key={index}>
                                        <Nav.Link eventKey={item.key}>
                                            {item.libelle}
                                            {!item.requiredFieldsFilled && (
                                                <div style={{ color: "red" }}>*</div>
                                            )}
                                        </Nav.Link>
                                    </Nav.Item>
                                ))}
                            </Nav>
                        )}
                        <Tab.Content>
                            {tableauData1.map((item, index) => (
                                <Tab.Pane eventKey={item.key}>
                                    {renderModalContent(item)}
                                </Tab.Pane>
                            ))}
                        </Tab.Content>
                    </Tab.Container>
                    <div style={{ marginBottom: "10px" }}>
                        {/* Add a message to inform that required fields are mandatory */}
                        <p style={{ color: "red" }}>
                            Les champs marqués d'une * sont obligatoires.
                        </p>
                    </div>
                    <div className="d-grid gap-2">
                        <Button
                            variant="primary"
                            size="lg"
                            onClick={saveAdherent}
                            disabled={!allRequiredFieldsFilled}
                        >
                            Enregistrer
                        </Button>
                    </div>
                </div>
            )}
            <Modal size="xl" show={showVilles} onHide={() => setShowVilles(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Villes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {villes.map((ville, index) => (
                        <div className="d-grid gap-2">
                            <Button className="outline-primary" key={index} onClick={() => handleVilleSelected(ville.localite)}>
                                {ville.localite}
                            </Button>
                        </div>
                    ))}
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AdherentUpdateById;
